import React from "react";
import "./HomeHeadingVid.css";
const HomeHeadingVidTxt = () => {
  return (
    <div className="homeHeadingTxtContainer">
      <div className="homeHeadingCover">
        <h2>
          Start Your German Language Learning Experience Now with{" "}
          <span> Prizma Academy's </span> Online Courses!
        </h2>
      </div>
    </div>
  );
};

export default HomeHeadingVidTxt;
